'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const createRenderState = require('./utils/create-render-state.js');
const scrapeMotionValues = require('./utils/scrape-motion-values.js');
const visualElement = require('./visual-element.js');
const useVisualState = require('../../motion/utils/use-visual-state.js');

var htmlMotionConfig = {
  createVisualElement: function (isStatic, options) {
    return visualElement.htmlVisualElement(options, {
      enableHardwareAcceleration: !isStatic
    });
  },
  useVisualState: useVisualState.makeUseVisualState({
    scrapeMotionValuesFromProps: scrapeMotionValues.scrapeMotionValuesFromProps,
    createRenderState: createRenderState.createHtmlRenderState
  })
};

exports.htmlMotionConfig = htmlMotionConfig;
